import {
  InvestmentStep,
  ReviewStep,
  InvestmentCompletedStep
} from '../components';

export enum EFundPensionInvestmentSteps {
  INVESTMENT,
  REVIEW,
  CONCLUSION
}

export const FundPensionInvestmentComponents = {
  [EFundPensionInvestmentSteps.INVESTMENT]: InvestmentStep,
  [EFundPensionInvestmentSteps.REVIEW]: ReviewStep,
  [EFundPensionInvestmentSteps.CONCLUSION]: InvestmentCompletedStep
};
